/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAngle = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M21 20H.8L14.2 4.3l1.5 1.3-6.1 7.1c.9.5 1.7 1.3 2.1 2.4.4.9.3 1.9-.1 2.9H21zM5.2 18h4.3c.5-.9.6-1.7.5-2.2-.2-.7-.9-1.1-1.5-1.5z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgAngle as Angle };
